import { FC, memo } from 'react'
import Head from 'next/head'

type Props = {
  title: string
  description?: string
  robotsContent?: string
}

const PageHead: FC<Props> = ({ title, description, robotsContent = 'noindex, follow' }) => {
  return (
    <Head>
      <title>{title}</title>
      <meta name="robots" content={robotsContent} />
      {description && <meta name="description" content={description} />}
    </Head>
  )
}

export default memo(PageHead)
